import Vue from 'vue'
import App from './App.vue'
// import router from './Routes'
import router from './router/index'
import store from './store/index'
import { sync } from 'vuex-router-sync' // Sync router with store
import vuetify from './plugins/vuetify'
// import * as VueGoogleMaps from 'vue2-google-maps';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import helpers from './helpers'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import VueMoment from 'vue-moment'
import moment from 'moment'

import InfiniteScroll from 'v-infinite-scroll'
import 'v-infinite-scroll/dist/v-infinite-scroll.css'

import "./plugins/vuetify-money.js";
import OTPInput from '@8bu/vue-otp-input';
import OtpInput from "@bachdgvn/vue-otp-input";

import interceptorsSetup from './interceptors2'
import Embed from 'v-video-embed'
import VueCountdown from '@chenfengyuan/vue-countdown';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import constant  from './Constant.js'

Vue.use(VueSweetalert2);

Vue.use(Embed);

interceptorsSetup()

Vue.component("vue-countdown", VueCountdown);

Vue.component("v-otp-input", OtpInput);

Vue.use(OTPInput);

// Vue.use(vuetify)
 
Vue.use(VueMoment, {
    moment,
})

Vue.use(InfiniteScroll)

// name is optional
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

const globalHelpers = {
  install () {
    Vue.helpers = helpers
    Vue.prototype.$helpers = helpers
  }
}

Vue.use(globalHelpers)

const globalConstant = {
  install(){
    Vue.constant = constant;
    Vue.prototype.$constant = constant;
  }
}
Vue.use(globalConstant);

Vue.use(Toast);
sync(store, router) // Sync store with router
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyB7OXmzfQYua_1LEhRdqsoYzyJOPh9hGLg',
//   },
// });

Vue.mixin({
  data() {
    return {
      vMoneyDefaultOpts: {
        locale: "id-ID",
        prefix: "Rp",
        suffix: "",
        length: 11,
        precision: 0
      },
      vMoneyDefaultOptsDollar: {
        locale: "us-US",
        prefix: "Rp",
        suffix: "",
        length: 11,
        precision: 0
      },
    }
  },
  methods: {
    hasFeature (featureCd) {
        const allowedFeature = store.state.features.filter( feature => {
            return feature.featureCd == featureCd
        })
        return allowedFeature.length > 0 ? true : false
    },
    requiredFeature (featureCd) {
      if (!this.hasFeature(featureCd)) {
        router.push({ name: "forbidden" });
      }
    },
    alamatOnly($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 44 || keyCode > 57) && keyCode !== 34 && keyCode !== 32 && keyCode !== 40 && keyCode !== 41 && (keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 122)) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    alamatAiOnly($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 44 || keyCode > 57) && keyCode !== 39 && keyCode !== 34 && keyCode !== 32 && keyCode !== 40 && keyCode !== 41 && (keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 122)) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    nameOnly($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode !== 32 && keyCode !== 44 && keyCode !== 46 && (keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 122)) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    numOnly($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57)) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    pasteNumOnly($event) {
      if($event.clipboardData.getData('text').match(/[^\d]/)) {
        $event.preventDefault();
      }
    },
    noPaste($event) {
      $event.preventDefault();
    },
    humanFormat (number, options) {
      if (options === undefined) {
          options = {
              locale: "id-ID",
              prefix: "",
              suffix: "",
              length: 11,
              precision: 0
          }
      }

      if (isNaN(number)) {
          number = 0;
      } else {
          // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
          number = Number(number).toLocaleString(options.locale, {
          maximumFractionDigits: options.precision,
          minimumFractionDigits: options.precision
          });
      }
      return number;
  },
  humanFormatUs (number, options) {
    if (options === undefined) {
        options = {
            locale: "en-US",
            prefix: "",
            suffix: "",
            length: 11,
            precision: 2
        }
    }

    if (isNaN(number)) {
        number = 0;
    } else {
        // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
        number = Number(number).toLocaleString(options.locale, {
        maximumFractionDigits: options.precision,
        minimumFractionDigits: options.precision
        });
    }
    return number;
}
  }
})

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
